import { createServerFn } from "@tanstack/react-start";
import { getServerCacheQueryClient } from "@/network/cache-query-client";
import { QueryKeysConfig } from "@/config/query-keys";
import { getPostComments as makeRequest } from "@/network/queries/get-post-comments";
import { loggingMiddleware } from "../middleware/server-fn/logging";
import * as v from "valibot";

const Schema = v.object({
  postId: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(0),
    v.transform((value) => String(value)),
  ),
});

export const getPostComments = createServerFn({ method: "GET" })
  .middleware([loggingMiddleware])
  .validator((data: v.InferInput<typeof Schema>) => v.parse(Schema, data))
  .handler(async ({ data }) => {
    const res = await getServerCacheQueryClient().ensureQueryData({
      queryKey: [QueryKeysConfig.postComments, data.postId],
      queryFn: () => makeRequest(data),
      revalidateIfStale: true,
    });
    return res;
  });
